import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10 2v4.66c0 .218 0 .326-.033.413a.47.47 0 01-.138.198c-.07.06-.183.102-.409.185a7.5 7.5 0 105.16 0c-.226-.083-.339-.125-.409-.185a.469.469 0 01-.138-.198C14 6.986 14 6.878 14 6.66V2M8.5 2h7"
    })
  ]))
}